import { connect } from 'react-redux';
import MonthlyReport from '../../../views/Finance/Report/Monthly.report.view';

export default connect(null, null)(MonthlyReport);
